import { Box, Grid, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { ApiResultModel, IDocument } from '../../../models/common.model';
import { IInnerStateCheque } from '../cheques/IInnerstate';
import { ICheqeuResponse, IGetCheqeuRequest, IUpdateCheque } from '../../../models/cheque.model';
import { RootState } from '../../../redux/store';
import { GetCheques, UpdateCheque } from '../../../services/cheque.service';
import ChequeRegisterSkeleton from '../cheques/register/chequeRegisterSkeleton';
import ElementTitle from '../../../components/title/elementTitle/elementTitle';
import CustomisedCardDivider from '../../../components/card/cardDivider';
import { NumberDisplay } from '../../../components/numberDisplay/numberDisplay';
import CustomisedErrorCard from '../../../components/card/errorCard';
import CustomisedTextField from '../../../components/textField/textField';
import CustomisedCardLoad from '../../../components/card/cardLoad';
import CustomisedCardUpload from '../../../components/card/cardUpload';
import CustomisedButton from '../../../components/button/button';
import ChequeGuide from '../../../components/chequeGuide/chequeGuide';
import { IGetGuarantorChequeRequest, IGetGuarantorChequeResponse, IRegisterGuarantorChequeRequest } from '../../../models/guarantor.model';
import { getGuarantorCheque, registerGuarantorCheque } from '../../../services/guarantor.service';
import { IDocumentTypeHints } from '../../../models/basicInformation.model';
import { DOCUMENT_TYPES } from '../../../config/cacheKey';
import { array } from 'yup';
import { toArray } from 'lodash';
import { convertLength } from '@mui/material/styles/cssUtils';
import { IGuarantorContainer } from '../../navigationButtonComponents/guarantorContainer/TGuarantorContainer';
import { useAppBar } from '../../../components/appBar/appBarContext';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { getFormRejectReasons } from '../../../services/registration.service';
import { IGetFormRejectReasonsResponse } from '../../../models/registration.model';

export default function GuarantorRegister({ setStep, setInnerState, referenceKey }: IGuarantorContainer) {
    const empthyFileArray = {} as IDocument;
    const { setHeader } = useAppBar();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const [sayadNumber, setSayadNumber] = useState<string>('');
    const [validationIssues, setValidationIssues] = useState<string[]>([]);
    const [frontImage, setFrontImage] = useState<IDocument | null>(empthyFileArray);
    const [rearImage, setRearImage] = useState<IDocument | null>(empthyFileArray);
    const [frontGuaranteeCheque, setFrontGuaranteeCheque] = useState<IDocumentTypeHints>();
    const [rearGuaranteeCheque, setRearGuaranteeCheque] = useState<IDocumentTypeHints>();
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);
    const [delImage, setDelImage] = useState<boolean>(false);
    const guarantorKey = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorKey
    );
    const [chequeData, setChequeData] = useState<IGetGuarantorChequeResponse>();
    const getNumber = (e: any) => {
        setSayadNumber(e.target.value);
    };
    const sayadNumberNumberCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
    };
    useEffect(() => {
        setDelImage(false);
        if (delImage === true) {
            GetGuarantorChequeMutation(request);
        }
    }, [delImage]);
    const { mutateAsync: RegisterGuarantorChequeMutation, isLoading: IRegisterGuarantorChequeRequest } =
        useMutation(registerGuarantorCheque, {
            onSuccess: (data: ApiResultModel<IGetGuarantorChequeResponse>) => {
                if (data.isSuccess) {
                    if (data.data) {
                        if (data && data?.data.isValid === true) {
                            setInnerState!('guarantorIntroduce')
                        }
                        if (data?.data.isValid === false) {
                            setValidationIssues(data.data.validationIssues);
                        }
                    }
                } else {
                    GetGuarantorChequeMutation(request);
                }
            }
        });

    async function fileURLToFile(fileUrl: any, fileName: any, originalFile: any) {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const file: any = new File([blob], fileName, { type: response.headers.get("Content-Type")! });
        file.preview = URL.createObjectURL(blob);
        return file;
    }

    const { mutateAsync: GetGuarantorChequeMutation, isLoading } =
        useMutation(getGuarantorCheque, {
            onSuccess: (data: IGetGuarantorChequeResponse) => {
                if (data) {
                    setChequeData(data);
                    setSayadNumber(data.sayadNumber);
                    setValidationIssues(data.validationIssues);
                    setFrontImage(data.frontImage);
                    setRearImage(data.rearImage);
                    setFrontGuaranteeCheque(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!)?.find((x: any) =>
                        x.documentType === 'FrontGuaranteeCheque'
                    ))
                    setRearGuaranteeCheque(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!)?.find((x: any) =>
                        x.documentType === 'RearGuaranteeCheque'
                    ))
                }
            },

            onError: (err) => {
                console.log(err);
            },
        });
    const request = {} as IGetGuarantorChequeRequest;
    request.referenceKey = referenceKey!;
    request.guarantorKey = guarantorKey;

    useEffect(() => {
        setHeader('ثبت چک ضمانت ضامن', 'guarantor');
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'guarantorIntroduce' + randomKeyForDispatch }));
        GetGuarantorChequeMutation(request);
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Guarantors'
        })
    }, []);
    const { mutate: GetRejectReasonsResidenceMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                if (data) {
                    let entityRejectReason: any[] = [];
                    let rejectReason: IGetFormRejectReasonsResponse[];
                    rejectReason = data.filter((item: any) => item.guarantorKey === guarantorKey);
                    rejectReason[0]?.entityRejectReasons.map((val: any) =>
                        val.rejectReasons.map((rej: any) =>
                            entityRejectReason.push(rej)
                        )
                    )
                    setRejectReasons(entityRejectReason);
                }
            },
        }
    );
    const handleCheque = async () => {
        const request = {} as IRegisterGuarantorChequeRequest;
        request.referenceKey = referenceKey!;
        request.sayadNumber = sayadNumber;
        request.guarantorKey = guarantorKey;
        request.frontImage = frontImage ? frontImage.file! ? frontImage.file
            : await fileURLToFile(`${frontImage.fileUrl}/true`, "myImage.jpg", frontImage) : null;
        ;
        request.rearImage = rearImage ? rearImage?.file
            ? rearImage?.file
            : await fileURLToFile(`${rearImage.fileUrl}/true`, "myRearImage.jpg", rearImage) : null;
        RegisterGuarantorChequeMutation(request);
    };
    const functionCheque = () => {
        setRearImage(null);
        const request = {} as IRegisterGuarantorChequeRequest;
        request.referenceKey = referenceKey!;
        request.sayadNumber = sayadNumber;
        request.guarantorKey = guarantorKey;
        request.frontImage = frontImage?.file!
        request.rearImage = undefined;
        RegisterGuarantorChequeMutation(request);
    }
    const functionChequeFront = () => {
        setFrontImage(null);
    }
    if (isLoading) {
        return <ChequeRegisterSkeleton />;
    }
    return (
        <div className="container-height-drawer">
            {chequeData && (
                <div className='content-container' style={{ marginBottom: '20px !important' }}>
                    <div className='drawer-content'>
                        <div>
                            <ChequeGuide
                                dueDatePersian={chequeData?.dueDatePersian!}
                                dueDateAlphabet={chequeData?.dueDateAlphabet!}
                                amount={chequeData?.amount!}
                                amountAlphabet={chequeData?.amountAlphabet!}
                                expectedHolder={chequeData?.expectedHolder!}
                                expectedIdCode={chequeData?.expectedIdCode!}
                                reasonTitle={chequeData!.reasonTitle}
                            />
                        </div>

                        {validationIssues?.length > 0 && (
                            <div className="mt-3">
                                <CustomisedErrorCard titleList={validationIssues} />
                            </div>
                        )}
                        {rejectReasons.length > 0 ? <div className="!mt-5">
                            <CustomisedErrorCard titleList={rejectReasons} />
                        </div> : ""

                        }
                        <div className="mt-6">
                            <ElementTitle title="ثبت چک صیادی و استعلام" />
                        </div>
                        <div className="!mt-5">
                            <CustomisedTextField
                                helperText={''}
                                error={false}
                                label=" شماره صیادی"
                                placeholder={'1234567891234567'}
                                required={true}
                                inputProps={{ type: 'tel', maxLength: 16, inputMode: 'numeric', lang: 'en' }}
                                value={sayadNumber}
                                onChange={getNumber}
                                name="sayadNumber"
                                id="sayadNumber"
                                onKeyDown={sayadNumberNumberCodeHandleKeyDown}
                            />
                        </div>
                        <Typography className="!mt-8 ">
                            در صورتی که چک شما{' '}
                            <b className="text-[#BBA57A]">دیجیتال</b>{' '}
                            میباشد، نیاز به بارگذاری تصویر رو و پشت چک نمیباشد
                        </Typography>

                        <div className="mt-8">
                            {frontImage?.fileUrl ? (
                                <CustomisedCardLoad
                                    title={'روی چک'}
                                    fileSelected={frontImage?.fileUrl}
                                    setChildValue={setFrontImage}
                                    fileArray={empthyFileArray}
                                    comment={frontGuaranteeCheque?.hints?.length! > 100
                                        ? toArray(frontGuaranteeCheque?.hints?.slice(0, 100) + '...') : toArray(frontGuaranteeCheque?.hints)}
                                    fileExtensions={frontGuaranteeCheque?.fileExtensions}
                                    maxSizeKb={frontGuaranteeCheque?.maxSizeKb}
                                    checkBySetad={true}
                                    functionCheque={functionChequeFront}
                                    setDelImage={
                                        setDelImage
                                    }
                                    fileType={frontImage?.file ? frontImage?.file.type : frontImage?.fileType}
                                />
                            ) : (
                                <CustomisedCardUpload
                                    title={'روی چک'}
                                    setFileSelected={setFrontImage}
                                    comment={frontGuaranteeCheque?.hints?.length! > 100
                                        ? toArray(frontGuaranteeCheque?.hints?.slice(0, 100) + '...') : toArray(frontGuaranteeCheque?.hints)}
                                    fileExtensions={frontGuaranteeCheque?.fileExtensions}
                                    maxSizeKb={frontGuaranteeCheque?.maxSizeKb}
                                />
                            )}
                        </div>
                        <div>
                            {rearImage?.fileUrl ? (
                                <CustomisedCardLoad
                                    title={'پشت چک'}
                                    fileSelected={rearImage?.fileUrl}
                                    setChildValue={setRearImage}
                                    fileArray={empthyFileArray}
                                    comment={rearGuaranteeCheque?.hints?.length! > 100
                                        ? toArray(rearGuaranteeCheque?.hints?.slice(0, 100) + '...') : (rearGuaranteeCheque?.hints)}
                                    fileExtensions={rearGuaranteeCheque?.fileExtensions}
                                    maxSizeKb={rearGuaranteeCheque?.maxSizeKb}
                                    functionCheque={functionCheque}
                                    checkBySetad={true}
                                    setDelImage={
                                        setDelImage
                                    }
                                    fileType={rearImage?.file ? rearImage?.file.type : rearImage?.fileType}
                                />
                            ) : (
                                <CustomisedCardUpload
                                    title={'پشت چک'}
                                    setFileSelected={setRearImage}
                                    comment={rearGuaranteeCheque?.hints?.length! > 100
                                        ? toArray(rearGuaranteeCheque?.hints?.slice(0, 100) + '...') : toArray(rearGuaranteeCheque?.hints)}
                                    fileExtensions={rearGuaranteeCheque?.fileExtensions}
                                    maxSizeKb={rearGuaranteeCheque?.maxSizeKb}
                                />
                            )}
                        </div>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            title={'ثبت چک'}
                            disable={!(sayadNumber?.length === 16)}
                            onClick={handleCheque}
                            type="submit"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
